import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=28eff223&scoped=true&"
import script from "./MenuNavigation.vue?vue&type=script&lang=js&"
export * from "./MenuNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MenuNavigation.vue?vue&type=style&index=0&id=28eff223&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eff223",
  null
  
)

export default component.exports